import React, { Fragment } from 'react'
import { Tooltip } from 'reactstrap'
import Info from '../../../assets/img/info.png'
import Close from '../../../assets/img/close.png'
import { useToggle } from '../../../utils/hooks'

const TooltipDropoffInfo = ({ container }) => {
  const [showTooltip, toggleTooltip] = useToggle(false)

  return (
    <Fragment>
      <img
        className="doorman_info"
        src={Info}
        alt="Info"
        id="dropoffInfo"
        onClick={toggleTooltip}
      />
      <Tooltip
        isOpen={showTooltip}
        placement="top"
        target="dropoffInfo"
        container={container}>
        <div className="doorman_tooltip_container">
          <div className="doorman_tooltip_title">
            <div>
              <span className="doorman_title_new">NEW</span>
              <span className="doorman_title_separator"> | </span>
              <span>Non-Contact Deliveries</span>
            </div>
            <img
              src={Close}
              alt="close"
              className="doorman_close"
              onClick={toggleTooltip}
            />
          </div>
          <div className="doorman_tooltip_body">
            We can leave your deliveries at your door so you can receive them
            without contact
          </div>
        </div>
      </Tooltip>
    </Fragment>
  )
}

export default TooltipDropoffInfo



// WEBPACK FOOTER //
// ./src/modules/Checkout/DeliveryDetails/TooltipDropoffInfo.jsx